export default __webpack_public_path__ + "static/media/RequestedDateIcon.22fab9e3.svg";